// extracted by mini-css-extract-plugin
export default {"container":"BillsLayout_container__Vx+Tv","contentContainer":"BillsLayout_contentContainer__cR+M9","content":"BillsLayout_content__heHN+"};